module.exports = __webpack_public_path__ + "img/pinned.0de45b6d.svg";